(function () {
  var PRODUCTION_HOSTS = ['www.autelpilot.com', 'autelpilot.com'];
  var FALLBACK_MESSAGE =
    'Intellectual property compliance content is only available on the live store domain. Please visit www.autelpilot.com/pages/intellectual-property-rights, or contact support@autelpilot.com for inquiries.';

  function isProductionHost() {
    return PRODUCTION_HOSTS.indexOf(window.location.hostname) !== -1;
  }

  function createFallback(message) {
    var fallback = document.createElement('p');
    fallback.className = 'cs-legal-embed__fallback';
    fallback.textContent = message || FALLBACK_MESSAGE;
    return fallback;
  }

  function createWrap() {
    var wrap = document.createElement('div');
    wrap.className = 'cs-legal-embed';
    return wrap;
  }

  function upgradeNineBillEmbeds(root) {
    var scope = root || document;
    var objects = scope.querySelectorAll('object[data*="9-bill.com"]');

    objects.forEach(function (obj) {
      var url = obj.getAttribute('data');
      if (!url) return;

      var wrap = createWrap();

      if (!isProductionHost()) {
        wrap.appendChild(createFallback());
        obj.replaceWith(wrap);
        return;
      }

      // Oceanpayment docs: /index/legal and /index/img use <img>, /index/text uses object/iframe.
      if (/\/index\/(legal|img)(?:\?|$)/i.test(url)) {
        var img = document.createElement('img');
        img.src = url;
        img.alt = 'Intellectual property rights';
        img.className = 'cs-legal-embed__image';
        img.loading = 'lazy';
        img.addEventListener('error', function () {
          img.hidden = true;
          if (!wrap.querySelector('.cs-legal-embed__fallback')) {
            wrap.appendChild(
              createFallback(
                'Legal content is temporarily unavailable. Please contact support@autelpilot.com for intellectual property inquiries.'
              )
            );
          }
        });
        wrap.appendChild(img);
      } else {
        var iframe = document.createElement('iframe');
        iframe.src = url;
        iframe.title = 'Legal information';
        iframe.loading = 'lazy';
        iframe.className = 'cs-legal-embed__frame';
        wrap.appendChild(iframe);
      }

      obj.replaceWith(wrap);
    });
  }

  function init() {
    upgradeNineBillEmbeds(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
